import styled from "styled-components";

export const Container = styled.div`
  @supports (container-type: inline-size) {
    container-type: inline-size;
  }
`;

type CompactTableWrapperProps = {
  $minWidth: number;
};

export const CompactTableWrapper = styled.div<CompactTableWrapperProps>`
  display: block;

  @supports (container-type: inline-size) {
    @container (min-width: ${({ $minWidth }) => $minWidth}px) {
      display: none;
    }
  }
`;

type StandardTableWrapperProps = {
  $minWidth: number;
};

export const StandardTableWrapper = styled.div<StandardTableWrapperProps>`
  display: none;

  @supports (container-type: inline-size) {
    @container (min-width: ${({ $minWidth }) => $minWidth}px) {
      display: block;
    }
  }
`;
